(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hegichi-frame-mood"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hegichi-frame-mood')) {
    customElements.define(
      'hegichi-frame-mood',
      class HegichiFrameMood extends HTMLElement {
        connectedCallback() {
          this.buttons = Array.from(this.querySelectorAll('[data-mood-button]'));
          this.panels = Array.from(this.querySelectorAll('[data-mood-panel]'));

          this.buttons.forEach((button) => {
            button.addEventListener('click', () => this.selectMood(button.dataset.moodButton));
          });
        }

        selectMood(selectedMood) {
          this.buttons.forEach((button) => {
            const isSelected = button.dataset.moodButton === selectedMood;
            button.classList.toggle('is-active', isSelected);
            button.setAttribute('aria-pressed', String(isSelected));
          });

          this.panels.forEach((panel) => {
            const isSelected = panel.dataset.moodPanel === selectedMood;

            if (isSelected) {
              panel.hidden = false;
              requestAnimationFrame(() => panel.classList.add('is-active'));
            } else {
              panel.classList.remove('is-active');
              panel.hidden = true;
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
